<template lang="pug">
  .how-to-videos.container
    .row.xs-f-small.md-f-medium.lg-f-small.max-at-tweak
      .fixed-width-tweak-upper
        .video-player-wrap.xs-12.xs-hide(:class="{'player-ready': runningVideo}")
          .a-box-xs-16x9
            .a-box-content
              video-player#mainVideo(mr-multi-video ref="mainVideo" v-show="runningVideo" :options="videoOptions")
              button.close-video.btn-reset.clickable.color-white.upper.xs-f-xsmall.max-at-tweak(@click="closeVideo") close video

        .videos-wrap.xs-12(:class="{ 'centered': centered }")
          video-item(v-for="(video, index) in videos" :key="index" :settings="video.settings" :runningVideo="runningVideo" @select="toggleVideo")
</template>

<script>
  import { defineAsyncComponent } from 'vue';

  export default {
    name: 'VideoGallery',

    components: {
      VideoPlayer: defineAsyncComponent(() => import('./VideoPlayer')),
      VideoItem: defineAsyncComponent(() => import('./VideoItem')),
    },

    props: {
      videos: {
        type: Array,
        default: () => [],
      },
      centered: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      runningVideo: undefined,
    }),

    computed: {
      videoOptions() {
        if (!this.runningVideo) {
          return;
        }
        const { url, code } = this.runningVideo;
        return {
          url,
          code,
          autoplay: true,
        };
      },
    },

    methods: {
      toggleVideo(video) {
        if (!this.runningVideo) {
          this.runningVideo = video;
          return;
        }
        if (this.runningVideo.code === video.code) {
          this.closeVideo();
          return;
        }
        this.runningVideo = video;
      },

      closeVideo() {
        this.$refs.mainVideo.player.pause();
        this.runningVideo = undefined;
      },
    },
  };
</script>

<style lang="stylus" scoped>
  .how-to-videos
    .row
      background-color #eee

    .video-player-wrap
      display block
      max-height 0
      min-height 0
      overflow hidden
      -moz-transition max-height 0.75s ease-in-out
      -ms-transition max-height 0.75s ease-in-out
      -o-transition max-height 0.75s ease-in-out
      -webkit-transition max-height 0.75s ease-in-out
      transition max-height 0.75s ease-in-out

      &.player-ready
        max-height 40em

    .videos-wrap
      padding 0 4%
      padding-bottom 1.5em
      &.centered
        text-align center
      .close-video
        position absolute
        z-index 10
        top 0.5em
        right 0.5em
</style>
